import validator from 'validator';
import isEmpty from 'lodash/isEmpty';

class FormValidator {

  constructor (rules) {
    if (rules || !isEmpty(rules)) {
      this.setRules(rules);
    }
  }

  setRules (rules) {
    if (this.validateRules(rules)) {
      this.rules = rules;
    }
  }

  showRules () {
    return this.rules;
  }

  validateRules (rules) {
    if (!rules || isEmpty(rules)) {
      throw new Error('Cannot set empty object as rules!');
    }

    let errors = [];

    Object.keys(rules).forEach((rule) => {
      if (!(rules[rule].hasOwnProperty('validate') && typeof rules[rule].validate === 'function')) {
        errors.push(`rule ${rule} is missing 'validate' method or it's not a function`);
      }
    });

    if (errors.length !== 0) {
      throw new TypeError(errors);
    } else {
      return true;
    }
  }

  validate (values) {
    if (!this.rules || isEmpty(this.rules)) {
      throw new Error('No Validation rules!');
    }

    let errors = {};

    Object.keys(values).forEach((key) => {
      if (this.rules[key]) {
        let validation = this.rules[key].validate(values[key]);

        if (!isEmpty(validation)) {
          errors[key] = validation;
        }
      }
    });

    return {
      error: !isEmpty(errors),
      errors: errors
    };
  }

}

export default FormValidator;


// WEBPACK FOOTER //
// ./client/helpers/FormValidator.js